module.exports = __webpack_public_path__ + "images/85a657ad8a0aca62e128e1fb690f2e0f.png";